module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    ref: "checkbox",
    staticClass: "rt-checkbox el-checkbox",
    class: [
      _vm.border && _vm.checkboxSize ? 'el-checkbox--' + _vm.checkboxSize : '',
      {
        'is-disabled': _vm.isDisabled
      },
      {
        'is-bordered': _vm.border
      },
      {
        'is-checked': _vm.isChecked
      },
      {
        'is-focus': _vm.focus
      },
      {
        'is-radio': _vm.isRadio
      }
    ],
    attrs: {
      "id": _vm.id,
      "role": "checkbox"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('span', {
    staticClass: "el-checkbox__input",
    class: {
      'is-disabled': _vm.isDisabled,
      'is-checked': _vm.isChecked,
      'is-indeterminate': _vm.indeterminate,
    },
    attrs: {
      "tabindex": _vm.indeterminate ? 0 : false,
      "role": _vm.indeterminate ? 'checkbox' : false,
      "aria-checked": _vm.indeterminate ? 'mixed' : false
    }
  }, [_c('span', {
    staticClass: "el-checkbox__inner"
  }, [(_vm.isChecked && !_vm.isRadio) ? _c('rt-icon', {
    attrs: {
      "name": "rt-base-irregular-check-lined",
      "color": "white",
      "size": "12"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rt-checkbox-radio-checked"
  })], 1), _vm._v(" "), (_vm.trueLabel || _vm.falseLabel) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "el-checkbox__original",
    attrs: {
      "aria-hidden": _vm.indeterminate ? 'true' : 'false',
      "true-value": _vm.trueLabel,
      "false-value": _vm.falseLabel,
      "disabled": _vm.isDisabled,
      "name": _vm.name,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, null) > -1 : _vm._q(_vm.model, _vm.trueLabel)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.model,
          $$el = $event.target,
          $$c = $$el.checked ? (_vm.trueLabel) : (_vm.falseLabel);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model = $$c
        }
      }, _vm.handleChange],
      "focus": function($event) {
        _vm.focus = true
      },
      "blur": function($event) {
        _vm.focus = false
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "el-checkbox__original",
    attrs: {
      "aria-hidden": _vm.indeterminate ? 'true' : 'false',
      "disabled": _vm.isDisabled,
      "name": _vm.name,
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.label,
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, _vm.label) > -1 : (_vm.model)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.model,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.label,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model = $$c
        }
      }, _vm.handleChange],
      "focus": function($event) {
        _vm.focus = true
      },
      "blur": function($event) {
        _vm.focus = false
      }
    }
  })]), _vm._v(" "), (_vm.$slots.default || _vm.label) ? _c('span', {
    staticClass: "el-checkbox__label"
  }, [_vm._t("default"), _vm._v(" "), (!_vm.$slots.default) ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8f2bb1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/checkbox/rtCheckbox.vue
// module id = 2208
// module chunks = 137